var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-pc-container"},[_c('div',{staticClass:"main-content flex-row"},[_c('left-nav-text-img'),_c('div',{staticClass:"main-right-content"},[_c('div',{staticClass:"view-wraper"},[_vm._m(0),_c('router-view',{attrs:{"name":"pc"}})],1)])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h2',[_c('span')])
}]

export { render, staticRenderFns }